import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { Restaurant } from "./Components/Restaurant";
import { restaurant as fallbackData } from "./Data";

export const useRestaurantData = () => {
  const [data, setData] = useState<Restaurant | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "config", "restaurant");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data() as Restaurant);
        } else {
          console.warn("No data found in Firestore, using local fallback.");
          setData(fallbackData);
        }
      } catch (err) {
        console.error("Error fetching restaurant data:", err);
        setError("Failed to load restaurant data.");
        setData(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};
